import { render, staticRenderFns } from "./pjBiddingFile.vue?vue&type=template&id=a4a3aa4e&scoped=true&"
import script from "./pjBiddingFile.vue?vue&type=script&lang=js&"
export * from "./pjBiddingFile.vue?vue&type=script&lang=js&"
import style0 from "./pjBiddingFile.vue?vue&type=style&index=0&id=a4a3aa4e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4a3aa4e",
  null
  
)

export default component.exports